var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mark',{class:{'color0': _vm.baz.key0 == _vm.text,'color1': _vm.baz.key1 == _vm.text,'color2': _vm.baz.key2 == _vm.text,'color3': _vm.baz.key3 == _vm.text,'color4': _vm.baz.key4 == _vm.text,'color5': _vm.baz.key5 == _vm.text,'color6': _vm.baz.key6 == _vm.text}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }